<template>
  <nav
    class="w-full bg-white border-b border-grayLight rounded-tl-[20px] h-[56px] px-8 flex justify-between items-center font-inter"
  >
    <div class="flex space-x-3 items-center">
      <component :is="getPageIcon(pageTitle)" class="w-4 h-4 mr-1" />
      <img
        src="@/assets/dashboard/chevron-right.svg"
        alt="Chevron icon"
        class="h-4"
      />  
      <p
        class="font-medium text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-md"
      >
        {{ pageTitle }}
      </p>
    </div>

    <div class="flex space-x-6 items-center">
      <div class="relative" ref="dropdown" @click="stopEventPropagation">
        <button
          @click="toggleDropdown"
          class="flex items-center focus:outline-none"
        >
          <div v-if="user && user.profile_picture" class="flex items-center">
            <img
              :src="user.profile_picture"
              alt="Profile Picture"
              class="w-10 h-10 rounded-full object-cover"
            />
          </div>
          <div v-else class="flex items-center">
            <UserAvatar
              :fullName="fullName"
              class="w-[32px] h-[32px] rounded-full bg-[#A3DB7D]"
            />
          </div>
        </button>

        <div
          v-if="dropdownOpen"
          class="absolute right-0 mt-2 text-[14px] w-72 bg-white border border-gray-200 rounded-md shadow-lg z-50"
        >
          <div
            class="flex gap-3 px-4 py-4 whitespace-nowrap border border-grayLight"
          >
            <router-link
              v-if="user && user.profile_picture"
              :to="{ name: 'Profile' }"
              class="flex items-center"
            >
              <img
                :src="user.profile_picture"
                alt="Profile Picture"
                class="w-10 h-10 rounded-full object-cover"
              />
            </router-link>
            <router-link
              v-else
              :to="{ name: 'Profile' }"
              class="flex items-center"
            >
              <UserAvatar
                :fullName="fullName"
                class="w-[40px] h-[40px] bg-[#A3DB7D]"
              />
            </router-link>

            <div class="max-w-[200px]">
              <p
                class="font-medium text-bodyText truncate overflow-hidden whitespace-nowrap"
              >
                {{ capitalize(user ? user.first_name : 'User') }}
                {{ capitalize(user ? user.last_name : '') }}
              </p>
              <p
                class="text-grayDark truncate overflow-hidden whitespace-nowrap"
              >
                {{ user ? user.email : 'user@example.com' }}
              </p>
            </div>
          </div>
          <div>
            <router-link
              :to="{ name: 'Profile' }"
              class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              View profile
            </router-link>
            <router-link
              :to="{ name: 'Settings' }"
              class="block px-6 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Settings
            </router-link>
            <button
              @click="logoutUser"
              class="block w-full text-left px-6 py-2 mb-4 text-sm text-gray-700 hover:bg-gray-100"
            >
              Log out
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import UserAvatar from './auth/UserAvatar.vue';
import DashboardIcon from './svg-icons/DashboardIcon.vue';
import FolderIcon from './svg-icons/FolderIcon.vue';
import TeamsIcon from './svg-icons/TeamsIcon.vue';
import TIIcon from './svg-icons/TIIcon.vue';
import PricingIcon from './svg-icons/PricingIcon.vue';
import DefaultPageIcon from './svg-icons/DefaultPageIcon.vue';

export default {
  name: 'HeaderComponent',
  components: {
    UserAvatar,
    DashboardIcon,
    FolderIcon,
    TeamsIcon,
    TIIcon,
    PricingIcon,
    DefaultPageIcon,
  },
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    fullName() {
      if (!this.user || (!this.user.first_name && !this.user.last_name)) {
        return 'User';
      }
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown);
  },
  methods: {
    getPageIcon(pageTitle) {
      switch (pageTitle.toLowerCase()) {
        case 'dashboard':
          return 'DashboardIcon';
        case 'projects':
        case 'goals':
          return 'FolderIcon';
        case 'teams':
          return 'TeamsIcon';
        case 'talent pool':
          return 'TIIcon';
        case 'pricing':
          return 'PricingIcon';
        default:
          return 'DefaultPageIcon';
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    stopEventPropagation(event) {
      event.stopPropagation();
    },
    capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    async logoutUser() {
      try {
        this.$store.commit('logout');
        console.log('User logged out and store cleared');
        await this.$router.replace({ name: 'Login' });
      } catch (error) {
        console.error('Error logging out:', error);
      }
    },
    showSuccessMessage(message) {
      this.$toast.success(message);
    },
    showErrorMessage(message) {
      this.$toast.error(message);
    },
  },
};
</script>